import { type FunctionComponent } from 'react';

import CalendarIcon from '@atlaskit/icon/core/calendar';
import { intl } from '@trello/i18n';
import {
  SpotlightManager,
  SpotlightTarget,
  SpotlightTransition,
} from '@trello/nachos/onboarding-experimental';
import type { PlannerTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import { IslandNavButton } from 'app/src/components/IslandNav';
import {
  PLANNER_DISCOVERY_SPOTLIGHT_TARGET,
  PlannerDiscoverySpotlight,
  useIsEligibleForPlannerDiscoverySpotlight,
} from 'app/src/components/PlannerDiscoverySpotlight';
import { ShortcutTooltip } from 'app/src/components/ShortcutTooltip';

interface PlannerNavigationButtonProps {
  showLabels?: boolean;
  isSelected: boolean;
  isDisabled: boolean;
  onClick: () => void;
}
export const PlannerNavigationButton: FunctionComponent<
  PlannerNavigationButtonProps
> = ({ showLabels, isSelected, isDisabled, onClick }) => {
  const { isEligible: isPlannerSpotlightEnabled } =
    useIsEligibleForPlannerDiscoverySpotlight();

  const plannerLabel = intl.formatMessage({
    id: 'templates.split_screen.planner',
    defaultMessage: 'Planner',
    description: 'Planner',
  });

  const plannerIcon = (
    <CalendarIcon
      label={
        showLabels
          ? ''
          : intl.formatMessage({
              id: 'templates.split_screen.planner',
              defaultMessage: 'Planner',
              description: 'Planner',
            })
      }
    />
  );

  const plannerNavButton = (
    <IslandNavButton
      icon={plannerIcon}
      isSelected={isSelected}
      isDisabled={isDisabled}
      onClick={onClick}
      testId={getTestId<PlannerTestIds>('panel-nav-planner-button')}
      showLabels={showLabels}
      label={plannerLabel}
    />
  );

  const plannerButton = isPlannerSpotlightEnabled ? (
    <SpotlightManager blanketIsTinted={true}>
      <PlannerDiscoverySpotlight />
      <SpotlightTransition>
        <SpotlightTarget name={PLANNER_DISCOVERY_SPOTLIGHT_TARGET}>
          {plannerNavButton}
        </SpotlightTarget>
      </SpotlightTransition>
    </SpotlightManager>
  ) : (
    <ShortcutTooltip
      shortcutText={plannerLabel}
      shortcutKey="g+p"
      position="top"
    >
      {plannerNavButton}
    </ShortcutTooltip>
  );
  return plannerButton;
};
